import * as React from "react";
interface props {
  className?: string;
}
const CalendarIcon = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width="24"
    // height="24"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#7D7D7D"
      d="M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3M6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3zm12.75 15h-15V9h15zm-6.375-7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0M9 16.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
    ></path>
  </svg>
);

export default CalendarIcon;
